var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsletter-badge"},[_vm._t("default",function(){return [_c('translate',{attrs:{"path":"Newsletter.badge","params":{ amount: _vm.newsletterDiscountInEuro }}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }